import React, { useState, useEffect } from "react";
import DivTag from "../Components/DivComponent/DivTag";
import Button from "../Components/ButtonComponent/Button";
import FormValidation from "../Components/FormValidation/FormValidation";
import InputWithLabel from "../Components/InputComponent/InputWithLabel";
import SelectWithLabelOption from "../Components/SelectComponent/SelectWithLabelOption";
import ReportHeading from "../Components/ReportHeadings/ReportHeadings";
import { motion } from "framer-motion";
import printTable from "../Components/TablePrintExcelPdfSearch/tablePrint";
import downloadExcel from "../Components/TablePrintExcelPdfSearch/downloadExcel";
import { fetchCustomerData } from "../../services/customerService";
import Seo from "../../components/SeoComponent/Seo";
import { PhysicalDocumentService } from "../../services/apiService";
import { showErrorToast, showSuccessToast } from "../../utils/toastUtils";
import PopMenu from "../../components/Dialog/PopMenu";
import Option from "../Components/OptionComponent/Option";
import { ToastContainer } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import EditCustomerModal from "./EditCusDetailsModal";
import PaginationData from "../../components/PaginationData";
import { Edit, Eye, ViewIcon } from "lucide-react";
import ViewCompanyDetails from "../../components/modals/ViewCompanyDetails";
import ViewCustomerDetails from "../../components/modals/ViewCustomerDetails";

const CustomerReport = () => {
  const initialState = {
    from_date: "",
    to_date: "",
    status: "",
    email_address: "",
    mobile: "",
    pan_number: "",
    aadhar_number: "",
    user_id: "",
    total_data: "50",
  };

  const validate = () => {
    let errors = {};
    return errors;
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [viewCompanyClicked, setViewCompanyClicked] = useState(false);
  const [viewUserClicked, setViewUserClicked] = useState(false);
  const [currentCustomerData, setCurentCustomerData] = useState(null);

  const handleEditClick = (user_id) => {
    setSelectedUserId(user_id);
    setIsModalOpen(true);
  };

  const { values, errors, handleChange, handleBlur } = FormValidation(
    initialState,
    validate,
  );
  const [physcialRemarks, setPhyscialRemarks] = useState("");
  const [physicalKycStatus, setPhysicalKycStatus] = useState("");
  const [userId, setUserId] = useState("");
  const [isOpen, setIsOpen] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [pagination, setPagination] = useState({
    total: 0,
    per_page: 50,
    current_page: 1,
    last_page: 1,
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(50);
  const handleOpenPhysicalKycApprove = (userId) => {
    setUserId(userId);
    setIsOpen(true);
    return;
  };
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const params = {
          from_date: values.from_date,
          to_date: values.to_date,
          status: values.status,
          user_id: values.user_id,
          aadhar_number: values.aadhar_number,
          pan_number: values.pan_number,
          mobile: values.mobile,
          email_address: values.email_address,
          page: currentPage,
          total_data: itemsPerPage,
        };

        const response = await fetchCustomerData(params);

        if (response.data && Array.isArray(response.data)) {
          setCustomerData(response.data);

          setPagination(response.pagination || {});
          setIsLoading(false);
          return;
        } else {
          console.error("Data format error:", response.data);
          setCustomerData([]);
          setPagination({});
          setIsLoading(false);
          return;
        }
      } catch (error) {
        console.error("Error fetching customer data:", error);
        setCustomerData([]);
        setPagination({});
        setIsLoading(false);
        return;
      }
    };

    fetchData();
  }, [values, currentPage, itemsPerPage, isOpen]);

  const handleSearchClick = async () => {
    setCurrentPage(1); // Reset to the first page on new search
    await fetchCustomerData({
      from_date: values.from_date,
      to_date: values.to_date,
      status: values.status,
      user_id: values.user_id,
      page: 1,
      total_data: itemsPerPage,
    });
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };

    return date.toLocaleDateString("en-US", options);
  };

  const filteredItems = customerData.map((item, index) => ({
    ...item,
    serialNumber: (currentPage - 1) * itemsPerPage + index + 1,
    user_id: item.user_id || "N/A",
    doc: item.doc ? formatDate(item.doc) : "N/A",
    name: item.name || "N/A",
    authorized_signatory: item.company_details
      ? item.company_details.authorized_person_name || "N/A"
      : "N/A",
    mobile_number: item.mobile_number || "N/A",
    company_cin: item.company_details
      ? item.company_details.company_cin || "N/A"
      : "N/A",
    company_address: item.company_details
      ? item.company_details.company_address || "N/A"
      : "N/A",
    signatory_address: item.landmark_address || "N/A",
    physical_kyc_status: item.kyc_status.value || "N/A",
    digital_kyc_status: item.digital_kyc_status.value || "N/A",
    account_status: item.status.value || "N/A",
  }));
  async function handlePhysicalDocument() {
    try {
      setIsLoading(true);
      const response = await PhysicalDocumentService({
        userId: userId,
        status: physicalKycStatus,
        remarks: physcialRemarks,
      });

      if (response.status.code === 200) {
        setPhyscialRemarks("");
        setPhysicalKycStatus("");
        //await UplodedDocumentLists();
        showSuccessToast("Document Approved Successfully");
        setIsLoading(false);
        setIsOpen(false);
        return;
      }
      setIsOpen(false);
      showErrorToast(response.message);
      return;
    } catch (error) {
      setPhyscialRemarks("");
      setPhysicalKycStatus("");
      setIsOpen(false);
      showErrorToast("Failed to approved ");
      setIsLoading(false);
      return;
    }
  }

  function handleSetPage(page) {
    setCurrentPage(page);
  }

  return (
    <motion.div
      initial={{ opacity: 0, y: -50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 1.2 }}
    >
      <Seo />
      {isLoading && <Loader />}
      <DivTag id="" className="mt-8 bg-white">
        <ReportHeading name="Customer Report" />
        <PopMenu
          visible={isOpen}
          onClose={() => setIsOpen(false)}
          className={"h-[60%] top-[10%] w-1/2"}
          title={"Physical Kyc Status"}
        >
          <h1 className="text-center my-1 text-xl font-semibold text-sky-400">
            Approved Kyc Document{" "}
          </h1>

          <p className="text-center my-1 text-xl font-semibold text-sky-400">
            Select userId : {userId}
          </p>
          <SelectWithLabelOption
            DivclassName="w-full  px-3 md:mb-0"
            label="Status"
            id="status"
            name="status"
            value={physicalKycStatus}
            onChange={(e) => setPhysicalKycStatus(e.target.value)}
            required={true}
          >
            <Option value="">Select Status</Option>
            <Option value="approve">Approve</Option>
            <Option value="reject">Reject</Option>
          </SelectWithLabelOption>

          <div className=" my-2 ">
            <h4 className="text-xl text-black font-bold">
              Remarks{" "}
              <span className="text-red-500 text-xl font-semibold">*</span>
            </h4>

            <textarea
              className="border-2 my-2 border-sky-400 shadow-md outline-none p-2 text-xl w-full
                             bg-white text-black"
              name="remarks"
              rows={4}
              cols={25}
              id=""
              value={physcialRemarks}
              onChange={(e) => setPhyscialRemarks(e.target.value)}
              placeholder="write your remarks"
            ></textarea>
          </div>
          <div className="flex w-full px-10 ml-10 justify-around items-center">
            <button
              className={
                isLoading
                  ? "cursor-not-allowed"
                  : "py-2 -ml-20 px-2 w-1/3 rounded bg-blue-500 text-white cursor-pointer hover:scale-105 transition-all"
              }
              onClick={handlePhysicalDocument}
              disabled={isLoading}
            >
              Submit{" "}
            </button>
          </div>
        </PopMenu>

        <DivTag className="flex flex-wrap gap-2 justify-center mt-1">
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-1 uppercase !text-sm"
            label="Search_UserId"
            type="text"
            name="user_id"
            id="user_id"
            placeholder={"API0030"}
            value={values.user_id}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.user_id ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.from_date}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-1 uppercase !text-sm"
            label="Search By PAN"
            type="text"
            name="pan_number"
            id="pan_number"
            placeholder={"BTUPJ7568H"}
            value={values.pan_number}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.pan_number ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.pan_number}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-1 uppercase !text-sm"
            label="Search By Aadhaar"
            type="text"
            name="aadhar_number"
            id="aadhar_number"
            placeholder={"301752453658"}
            value={values.aadhar_number}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.aadhar_number ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.aadhar_number}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-1 uppercase !text-sm"
            label="Search By Mobile"
            type="text"
            name="mobile"
            id="mobile"
            placeholder={"7236958568"}
            value={values.mobile}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.mobile ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.mobile}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-1 uppercase !text-sm"
            label="Search By Email Id"
            type="text"
            name="email_address"
            id="email_address"
            placeholder={"abc@example.com"}
            value={values.email_address}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.email_address ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.email_address}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-2"
            label="From Date"
            type="date"
            name="from_date"
            id="from_date"
            value={values.from_date}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.from_date ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.from_date}
          />
          <InputWithLabel
            DivclassName="w-full md:w-1/6 px-2"
            label="To Date"
            type="date"
            name="to_date"
            id="to_date"
            value={values.to_date}
            onChange={handleChange}
            onBlur={handleBlur}
            className={`border rounded-md py-2 px-3 ${
              errors.to_date ? "border-red-500" : "border-blue-600"
            }`}
            error={errors.to_date}
          />
          <SelectWithLabelOption
            DivclassName="w-full md:w-1/6 px-2"
            label="Records Per Page"
            name="total_data"
            id="total_data"
            value={values.total_data}
            onChange={(e) => {
              handleChange(e);
              setItemsPerPage(Number(e.target.value)); // Update itemsPerPage state
            }}
            className="border  rounded-md py-2 px-3 border-blue-600"
          >
            <option value="50">50</option>
            <option value="100">100</option>
          </SelectWithLabelOption>
        </DivTag>

        <DivTag className="flex justify-center mt-1">
          <Button
            type="button"
            onClick={handleSearchClick}
            className="bg-blue-700 text-white rounded-md px-1 py-0 hover:bg-blue-800 transition duration-300"
          >
            Search
          </Button>
        </DivTag>

        <DivTag className="overflow-x-auto my-1 p-2">
          <table id="table " className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50 sticky top-0">
              <tr className="bg-blue-700 text-center text-white">
                {/* <th
                  scope="col"
                  className="p-2 text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  S.No
                </th> */}
                <th
                  scope="col"
                  className="p-2 text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  User_ID
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Doc
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  View User
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  View Company
                </th>
                {/* <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Authorized_Signatory
                </th>
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Company_name
                </th> */}
                {/* <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Mobile
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Pan
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Aadhar
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Email
                </th>
                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Address
                </th>

                <th
                  scope="col"
                  className=" text-xs  font-bold uppercase tracking-wider text-center border border-black"
                >
                  Mobile_Number
                </th>

                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Company_CIN
                </th>
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Company_Address
                </th>
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Signatory_Address
                </th> */}
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Edit
                </th>
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Physical_KYC_Status
                </th>
                <th
                  scope="col"
                  className="text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Digital_KYC_Status
                </th>
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Account_Status
                </th>
                <th
                  scope="col"
                  className=" text-xs font-bold uppercase tracking-wider text-center border border-black"
                >
                  Approve_Physcial_Kyc
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {filteredItems.map((item) => (
                <tr key={item?.serialNumber} className="">
                  {/* <td className="p-1 whitespace-nowrap text-sm font-medium text-gray-900 border border-black text-center">
                    {item.serialNumber}
                  </td> */}
                  <td className=" whitespace-nowrap text-sm font-medium text-gray-900 border border-black text-center">
                    {item.user_id}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.doc}
                  </td>
                  {/* <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item?.company_details?.authorized_person_name ||
                      item?.company_details?.company_name ||
                      "-"}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item?.company_details?.company_name}
                  </td> */}
                  {/* <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.mobile_number}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.pan_number}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.aadhar_number}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.email_address}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.landmark_address}
                  </td>

                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.mobile_number}
                  </td>

                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.company_cin}
                  </td>
                  <td className="whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.company_address}
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.signatory_address}
                  </td> */}

                  <td className=" whitespace-nowrap text-sm align-middle  text-gray-500 border border-black text-center">
                    <button
                      onClick={() => {
                        setViewUserClicked(true);
                        setCurentCustomerData(item);
                      }}
                      className="w-full flex justify-center"
                    >
                      <span className="rounded-md py-[2px] px-3 bg-blue-100 text-blue-800 border border-blue-500 text-xs">
                        <Eye size={20} className="text-blue-600 " />
                      </span>{" "}
                    </button>
                  </td>
                  <td className=" whitespace-nowrap text-sm align-middle  text-gray-500 border border-black text-center">
                    <button
                      onClick={() => {
                        setViewCompanyClicked(true);
                        setCurentCustomerData(item);
                      }}
                      className="w-full flex justify-center"
                    >
                      <span className="rounded-md py-[2px] px-3 bg-blue-100 text-blue-800 border border-blue-500 text-xs">
                        <Eye size={20} className="text-blue-600 " />
                      </span>
                    </button>
                  </td>

                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center px-2">
                    <button
                      className="rounded-md py-1 px-3 bg-amber-100 text-amber-800 border border-amber-500 text-xs"
                      onClick={() => handleEditClick(item?.user_id)}
                    >
                      <Edit size={16} />
                    </button>
                  </td>

                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    <button
                      className={
                        item.physical_kyc_status === "approved"
                          ? "bg-green-100 text-green-800 border-green-500 border rounded-full px-2 py-[2px]"
                          : "bg-red-100 text-red-800 border-red-500 border rounded-full px-2 py-[2px]"
                      }
                    >
                      {item.physical_kyc_status}
                    </button>
                  </td>
                  <td className=" whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    <button className="bg-red-100 text-red-800 border-red-500 border rounded-full px-2 py-[2px]">
                      {item.digital_kyc_status}
                    </button>
                  </td>
                  <td className="whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    <button className="bg-green-100 text-green-800 border-green-500 border rounded-full px-2 py-[2px]">
                      {" "}
                      {item.account_status}
                    </button>
                  </td>
                  <td className="whitespace-nowrap text-sm text-gray-500 border border-black text-center">
                    {item.physical_kyc_status === "approved" ? (
                      <p className="text-green-500">Physcial Kyc Approved</p>
                    ) : item.physical_kyc_status === "rejected" ? (
                      <p className="text-red-500">Physical Kyc Rejected</p>
                    ) : item.physical_kyc_status === "pending" ? (
                      <button
                        className="py-1 m-1  px-1  rounded bg-sky-900 text-white cursor-pointer hover:scale-105 transition-all"
                        onClick={() =>
                          handleOpenPhysicalKycApprove(item?.user_id)
                        }
                      >
                        Approve Physical Kyc{" "}
                      </button>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </DivTag>
        <ToastContainer />
        <div className="flex justify-center my-2">
          <PaginationData
            currentPage={currentPage}
            lastPage={pagination?.last_page}
            handlePage={handleSetPage}
          />
        </div>
        <DivTag className="flex p-4 justify-center mt-4">
          {isModalOpen && (
            <EditCustomerModal
              isOpen={isModalOpen}
              onClose={() => setIsModalOpen(false)}
              userId={selectedUserId}
              onUpdate={fetchCustomerData}
            />
          )}
        </DivTag>
      </DivTag>

      <ViewCustomerDetails
        onClose={() => setViewUserClicked(false)}
        isOpen={viewUserClicked}
        userData={currentCustomerData}
      />
      <ViewCompanyDetails
        onClose={() => setViewCompanyClicked(false)}
        isOpen={viewCompanyClicked}
        companyData={currentCustomerData}
      />
    </motion.div>
  );
};

export default CustomerReport;
